import React from "react";
import { CrownIcon } from "lucide-react";
import { tomos } from "../data/salesContent";
export function Tomos() {
  return <section aria-labelledby="incluye" className="w-full bg-white py-16 lg:py-24" data-id="element-177" data-mp="13cz7ft09dx6o">
      <div className="mx-auto max-w-6xl px-5" data-id="element-178" data-mp="1h44dpdy4tnpz">
        <div className="max-w-2xl" data-id="element-179" data-mp="1h4xd1turhay3">
          <p className="font-display text-sm font-extrabold uppercase tracking-widest text-gold-deep" data-id="element-180" data-mp="1cbujvmtwc3if">
            Lo que incluye
          </p>
          <h2 id="incluye" className="mt-2 font-display text-3xl font-black text-ink sm:text-5xl" data-id="element-181" data-mp="1qzfjv7vh5mm4">
            6 tomos completos
          </h2>
          <p className="mt-4 text-lg text-muted" data-id="element-182" data-mp="201ovk12hbm13">
            Todo el negocio, de la receta al cobro. Más de 420 páginas organizadas en el orden en
            que las vas a usar.
          </p>
        </div>

        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-183" data-mp="5ne5xqe28nu9">
          {tomos.map(t => <article key={t.number} className="flex flex-col overflow-hidden rounded-2xl border border-cream-deep bg-cream" data-id="element-184" data-mp="1n3z6big1tec">
              <div className={`${t.color} p-3`} data-id="element-185" data-mp="34sazrv3ygyi0">
                <div className="flex flex-col items-center overflow-hidden rounded-lg border border-gold/60 pt-4 text-center" data-id="element-186" data-mp="39pjka2cktemf">
                  <CrownIcon className="h-4 w-4 fill-gold text-gold" aria-hidden="true" data-id="element-187" data-mp="3enutqbyyln44" />
                  <p className="mt-1 font-display text-sm font-extrabold uppercase tracking-wider text-gold-bright" data-id="element-188" data-mp="3jfw23mt0atov">
                    Tomo {t.number}
                  </p>
                  <p className="mt-0.5 font-display text-2xl font-black uppercase leading-tight text-white" data-id="element-189" data-mp="3sgash0ktuyz8">
                    {t.short}
                  </p>
                  <img src={t.image} alt={t.imageAlt} loading="lazy" className="mt-2 h-44 w-full object-cover" data-id="element-190" data-mp="1ast3qzx5xj6" />
                </div>
              </div>
              <div className="flex flex-1 flex-col p-6" data-id="element-191" data-mp="27zxmf03bp9eo">
                <h3 className="font-display text-xl font-extrabold text-ink" data-id="element-192" data-mp="282jv531y9uyh">{t.title}</h3>
                <p className="mt-2 leading-relaxed text-muted" data-id="element-193" data-mp="2001e25wtlx7s">{t.description}</p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}